function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ContactsTable from "../components/contacts/ContactsTable";
import PageHeader from "../components/common/PageHeader";
import Actions from "../components/contacts/Actions";
import t from "../scripts/i18n";
import "../styling/pages/Contacts.css";

var Contacts = function Contacts(props) {
  var dispatch = useDispatch();
  var state = useSelector(function (state) {
    return state.contacts;
  });
  var tableState = state.tableState;

  var handleSearchContacts = function handleSearchContacts(e) {
    dispatch({
      type: "SET_TABLE_STATE",
      tableState: _objectSpread(_objectSpread({}, tableState), {}, {
        currentPage: 1,
        wildcard: e
      })
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "page-container"
  }, /*#__PURE__*/React.createElement(PageHeader, {
    title: "".concat(t("contacts_page_header"), " (").concat(state.total, ")"),
    onSearch: handleSearchContacts
  }, " "), /*#__PURE__*/React.createElement(ContactsTable, null), /*#__PURE__*/React.createElement(Actions, null));
};

export default Contacts;